export { TouristsOrderInfoList as TouristOrderInfo } from "./components/TouristsOrderInfoList";
